export default __webpack_public_path__ + "static/media/Comfortaa-Light.8d7e182e.ttf";